// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deeplink-modal-content>iframe{width:100%;border:0 solid #fff;height:440px}", ""]);
// Exports
module.exports = exports;
